export * from './full-layout.component';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/containers/full-layout/index.ts